import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, PropertyGroup } from '../../components';

import css from './CustomExtendedDataSection.module.css';

const SectionMultiEnum = props => {
  const {
    heading,
    options,
    selectedOptions,
    idPrefix,
    className,
    rootClassName,
    showUnselectedOptions = true,
  } = props;
  if (!heading || !options) {
    return null;
  }
  const hasSelectedOptions = selectedOptions?.length > 0;

  // When unselected options are hidden, an empty selection would otherwise render
  // an empty list. Show a "None" fallback instead so the heading isn't orphaned.
  const showEmptyState = !showUnselectedOptions && !hasSelectedOptions;

  const idSlug = heading.toLowerCase().replace(/ /g, '_');

  const classes = classNames(rootClassName || css.sectionMultiEnum, className);

  // When unselected options are hidden, base the column count on what's actually
  // visible instead of the full option list, to avoid a sparse two-column layout.
  const visibleOptionsCount = showUnselectedOptions ? options.length : selectedOptions.length;

  return (
    <section className={classes}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      {showEmptyState ? (
        <p className={css.noOptionsSelected}>
          <FormattedMessage id="SectionMultiEnum.noOptionsSelected" />
        </p>
      ) : (
        <PropertyGroup
          id={`${idPrefix}.${idSlug}`}
          ariaLabel={heading}
          options={options}
          selectedOptions={selectedOptions}
          twoColumns={visibleOptionsCount > 5}
          showUnselectedOptions={showUnselectedOptions}
        />
      )}
    </section>
  );
};

export default SectionMultiEnum;
